module.exports = __webpack_public_path__ + "img/zs.70ab6dde.png";